import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Detect user language
import translation_en from "./locales/en/translation.json";
import translation_pl from "./locales/pl/translation.json";

// Function to get language from URL query parameter
const getLanguageFromURL = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && ['en', 'pl'].includes(langParam.toLowerCase())) {
      return langParam.toLowerCase();
    }
  }
  return null;
};

const resources = {
  en: {
    translation: translation_en
  },
  pl: {
    translation: translation_pl
  },
};

// Configure language detector with custom detection
const languageDetectorOptions = {
  // Order of detection methods
  order: ['querystring', 'navigator', 'htmlTag', 'localStorage'],
  // Keys or params to lookup language from
  lookupQuerystring: 'lang',
  // Cache user language detection
  caches: ['localStorage'],
  // Only detect languages that are in the 'resources' object
  checkWhitelist: true
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "pl", // Default language
    defaultNS: 'translation',
    detection: languageDetectorOptions,
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;